export default {
    'name': 'citation-patent',
    'label': 'structureTable.patent',
    'getComponent': () => import('./citation-patent.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/citation/patent',
};
